
import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import * as React from 'react';

class _PleaseWait extends React.Component<StyledComponentProps> {
	render() {
		const classes = this.props.classes || {};
		return <div className={classes.outer}>
			<div className={classes.inner}>
				<CircularProgress style={{width: 80, height: 80}} className={classes.progress}/>
			</div>
		</div>;
	}
}

const styles = createStyles({
	outer: {
		height: '80%',
		display: 'flex',
		justifyContent: 'space-evenly',
		alignItems: 'center',
		flex: 1,
	},
	inner: {
		display: 'flex',
	},
	progress: {
	}
});

export const PleaseWait = withStyles(styles)(_PleaseWait);
